import { BaseDevice, CustomLayout } from '../base_device'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import { getDeviceKeySquare } from './keysquare/keysquare'
import list_icon from '@/assets/img/device/op75/list_icon.png'
import { op75VKCodes } from './keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_OP75 } from '../light/light_effect_list'
export class OP75 extends BaseDevice {
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_OP75
  y_number: number = 6
  square = getDeviceKeySquare(DevicePid.IYXOp75)
  vkcodes = op75VKCodes
  fnDisableKeys: KK[] = [0, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 7, 13, 19, 25, 31, 56, 62, 91, 92, 93, 59]
  name: string = 'OP75'
  icon: string = list_icon
  width: number = 665
  customLayout: CustomLayout = {
    0xc: this.createSquare(40.5, 2),
    0x24: this.createSquare(20.6, 2),
    0x3c: this.createSquare(20.6, 2),
    0x54: this.createSquare(2, 2),
    0x1: this.createSquare(2, this.y_number),
    0x7: this.createSquare(2, this.y_number),
    0xd: this.createSquare(2, this.y_number),
    0x13: this.createSquare(2, this.y_number),
    0x19: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x2b: this.createSquare(2, this.y_number),
    0x31: this.createSquare(2, this.y_number),
    0x37: this.createSquare(2, this.y_number),
    0x3d: this.createSquare(2, this.y_number),
    0x43: this.createSquare(2, this.y_number),
    0x49: this.createSquare(2, this.y_number),
    0x4f: this.createSquare(2, this.y_number, 73, 36.5),
    0x5b: this.createSquare(2, this.y_number),
    0x2: this.createSquare(2, 2, 54.8, 36.5),
    0x50: this.createSquare(2, 2, 54.8, 36.5),
    0x5c: this.createSquare(2, 2),
    0x3: this.createSquare(2, 2, 67.5, 36.5),
    0x51: this.createSquare(2, 2, 80.3, 36.5),
    0x4: this.createSquare(2, 2, 87.6, 36.5),
    0x52: this.createSquare(2, 2, 58, 36.5),
    0x58: this.createSquare(4, 2),
    0x5: this.createSquare(2, 2, 47.5, 36.5),
    0xb: this.createSquare(2, 2, 47.5, 36.5),
    0x11: this.createSquare(2, 2, 47.5, 36.5),
    0x23: this.createSquare(2, 2, 238, 36.5),
    0x35: this.createSquare(2, 2, 47.5, 36.5),
    0x3b: this.createSquare(2, 2, 47.5, 36.5),
    0x53: this.createSquare(12, 2),
  }
  inoperableKeys: KK[] = [0x3b]
}
